import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import FloatingLines from './FloatingLines';

const Hero = () => {
    const { t } = useLanguage();
    const styles = {
        section: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            paddingTop: '72px',
            overflow: 'hidden',
            background: '#0a1014',
        },
        linesContainer: {
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            opacity: 0.4,
        },
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '80px 32px',
            textAlign: 'center',
            position: 'relative',
            zIndex: 10,
        },
        h1: {
            fontSize: '64px',
            fontWeight: '800',
            lineHeight: '1.1',
            marginBottom: '24px',
            color: '#FFFFFF',
            textShadow: '0 2px 20px rgba(0,0,0,0.5), 0 4px 40px rgba(0,0,0,0.3)',
        },
        highlight: {
            background: 'linear-gradient(135deg, #3457D5 0%, #F28C46 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 2px 10px rgba(52,87,213,0.5))',
        },
        subtitle: {
            fontSize: '32px',
            fontWeight: '700',
            color: '#E4ECFF',
            marginBottom: '20px',
            textShadow: '0 2px 15px rgba(0,0,0,0.4)',
        },
        description: {
            fontSize: '20px',
            color: '#BEBEBE',
            maxWidth: '800px',
            margin: '0 auto 40px',
            lineHeight: '1.7',
            textShadow: '0 2px 10px rgba(0,0,0,0.4)',
        },
        buttonContainer: {
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginTop: '40px',
        },
        primaryButton: {
            padding: '18px 40px',
            backgroundColor: '#D81F26',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '999px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            boxShadow: '0 4px 20px rgba(216,31,38,0.3)',
        },
        secondaryButton: {
            padding: '18px 40px',
            backgroundColor: 'transparent',
            color: '#3457D5',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '999px',
            border: '2px solid #3457D5',
            cursor: 'pointer',
            transition: 'all 0.3s',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.h1.fontSize = '36px';
        styles.subtitle.fontSize = '24px';
        styles.description.fontSize = '16px';
        styles.buttonContainer.flexDirection = 'column';
        styles.container.padding = '60px 20px';
    }

    return (
        <section style={styles.section}>
            <div style={styles.linesContainer}>
                <FloatingLines
                    linesGradient={['#3457D5', '#F28C46', '#3457D5']}
                    enabledWaves={['top', 'middle', 'bottom']}
                    lineCount={[10, 15, 20]}
                    lineDistance={[8, 6, 4]}
                    bendRadius={5.0}
                    bendStrength={-0.5}
                    interactive={true}
                    parallax={true}
                />
            </div>

            <div style={styles.container}>
                <h1 style={styles.h1}>
                    {t('hero.title')}{' '}
                    <span style={styles.highlight}>{t('hero.titleHighlight')}</span>
                </h1>
                <p style={styles.subtitle}>{t('hero.subtitle')}</p>
                <p style={styles.description}>
                    {t('hero.description')}
                </p>
                <div style={styles.buttonContainer}>
                    <button
                        style={styles.primaryButton}
                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                        onClick={() => window.location.href = '/dashboard?newOrder=true'}
                    >
                        {t('hero.cta')}
                    </button>
                    <button
                        style={styles.secondaryButton}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#3457D5';
                            e.target.style.color = '#FFFFFF';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.color = '#3457D5';
                        }}
                        onClick={() => window.location.href = '/#contact'}
                    >
                        {t('hero.secondaryCta')}
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Hero;
